export default __webpack_public_path__ + "static/lifeprint-demo-1-5af7284f3669a66b5684c7bbc139a235.webp";